import React from 'react';

export const RelatedPhotos = ({ photos, categoryName, onPhotoClick }) => {
  if (photos.length === 0) return null;

  return (
    <div className="mt-24" data-testid="related-photos">
      <h2 className="section-title text-center mb-12">More {categoryName} Photography</h2>
      <div className="grid grid-cols-1 md:grid-cols-3 gap-4">
        {photos.slice(0, 3).map((photo) => (
          <div
            key={photo.id}
            className="portfolio-card cursor-pointer"
            onClick={() => onPhotoClick(photo.id)}
            data-testid={`related-photo-${photo.id}`}
          >
            <img src={photo.image} alt={photo.title} />
          </div>
        ))}
      </div>
    </div>
  );
};
